import { EMPTY_BANKER_MODEL } from "presentation/model/Banker/BankerModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: BankerProvider,
    useTracked: useBankerTracked
} = createContainer(() => useState(EMPTY_BANKER_MODEL), { concurrentMode: true });
export { BankerProvider, useBankerTracked };

